import { createContext } from 'react';

export const defaultFeatureFlagContextValues = {
  isSelectVenueActive: false,
  isWebView: false,
  isXceedAccess: false,
  isPublicEventReportPage: false,
  testCompanyIds: '',
  externalPlatformEnabledIds: '',
  isExternalPlatformSectionEnabled: false,
  isUserResetPasswordEnabled: false,
  isOfflineSalesPassScopeEnabled: false,
};

export const FeatureFlagContext = createContext(defaultFeatureFlagContextValues);
